import { MapTo } from '@adobe/aem-react-editable-components';
import FeatureDetailCard, { FeatureDetailCardEditConfig } from './FeatureDetailCard';

export default MapTo('cob-corp-acquisition/components/creditonebank/feature-detail-card')(FeatureDetailCard, FeatureDetailCardEditConfig);